import { motion, useReducedMotion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

// `mount` = animate immediately on mount (reliable even below the fold / after
// route changes). Otherwise animate when scrolled into view.
export const Reveal = ({
  children,
  delay = 0,
  y = 24,
  duration = 0.65,
  className = "",
  once = true,
  mount = false,
  ...props
}) => {
  const reduce = useReducedMotion();
  const animateProps = mount
    ? { animate: reduce ? { opacity: 1 } : { opacity: 1, y: 0 } }
    : {
        whileInView: reduce ? { opacity: 1 } : { opacity: 1, y: 0 },
        viewport: { once, margin: "-120px 0px -80px 0px" },
      };
  return (
    <motion.div
      className={className}
      initial={reduce ? { opacity: 0 } : { opacity: 0, y }}
      {...animateProps}
      transition={{ duration, ease: EASE, delay }}
      {...props}
    >
      {children}
    </motion.div>
  );
};

// Container that reveals children near-simultaneously with a tiny stagger.
export const RevealGroup = ({
  children,
  className = "",
  stagger = 0.08,
  mount = false,
}) => {
  const reduce = useReducedMotion();
  const animateProps = mount
    ? { animate: "show" }
    : {
        whileInView: "show",
        viewport: { once: true, margin: "-120px 0px -80px 0px" },
      };
  return (
    <motion.div
      className={className}
      initial="hidden"
      {...animateProps}
      variants={{
        hidden: {},
        show: { transition: { staggerChildren: reduce ? 0 : stagger } },
      }}
    >
      {children}
    </motion.div>
  );
};

export const RevealItem = ({ children, className = "", y = 26 }) => {
  const reduce = useReducedMotion();
  return (
    <motion.div
      className={className}
      variants={{
        hidden: reduce ? { opacity: 0 } : { opacity: 0, y },
        show: {
          opacity: 1,
          y: 0,
          transition: { duration: 0.65, ease: EASE },
        },
      }}
    >
      {children}
    </motion.div>
  );
};
